/* =================== CONTADORES =================== */
(function () {
  "use strict";

  // Variáveis
  const $counters = $("[data-count]");
  const duration = 2000;

  // Verifica os contadores existem
  if ($counters.length > 0) {
    // Inicia os contadores quando estiverem visíveis na tela
    doWhenVisible($counters, function () {
      $counters.each(function () {
        // Variáveis
        const $el = $(this);
        const countTo = $el.attr("data-count");

        // Contador
        $({
          countCur: $el.text(),
        }).animate(
          {
            countCur: countTo,
          },
          {
            duration: duration,
            easing: "swing",
            step: function () {
              $el.text(Math.floor(this.countCur));
            },
            complete: function () {
              $el.text(this.countCur);
            },
          }
        );
      });
    });
  }
})();
